'use client';

import { MoonIcon, SunIcon } from '@radix-ui/react-icons';
import Cookies from 'js-cookie';
import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { toggleTheme } from '@/app/lib/store/theme-slice';
import { IconButton } from '@radix-ui/themes';

export default function ThemeSwitcher() {
  const theme = useAppSelector(state => state.theme.mode);
  const dispatch = useAppDispatch();

  const handleToggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    dispatch(toggleTheme());
    Cookies.set('theme', newTheme);

    document.documentElement.className = `${newTheme}-theme`;

    const themeElement = document.getElementById('theme');
    if (themeElement && themeElement.classList.contains('dark')) {
      themeElement.classList.replace('dark', 'light');
    } else if (themeElement) {
      themeElement.classList.replace('light', 'dark');
    }
  };

  return (
    <IconButton
      className='icon-button-no-background'
      variant='ghost'
      onClick={handleToggleTheme}
      aria-label='Кнопка переключения темы'
    >
      {theme === 'light' ? <MoonIcon /> : <SunIcon />}
    </IconButton>
  );
}
